import PropTypes from 'prop-types';
import DeliveryOption from '../shared/delivery/DeliveryOption';
import { FormattedMessage } from 'dibs-react-intl';

function BuyerNeedsDeliveryQuote({ shipmentType, shipmentQuoteId, onSelect, isComputing }) {
    const isSelected = shipmentType === 'FIRSTDIBS_FACILITATED' && !shipmentQuoteId;

    const description = (
        <FormattedMessage
            id="checkout.BuyerNeedsDeliveryQuote.description"
            defaultMessage="Expect the shipping quote within 48 hours. You will be able to approve any additional costs."
        />
    );

    return (
        <DeliveryOption
            value="quoteNeeded"
            title={
                <FormattedMessage
                    id="checkout.BuyerNeedsDeliveryQuote.title"
                    defaultMessage="Arrange shipping via 1stDibs"
                />
            }
            description={description}
            testName="FIRSTDIBS_FACILITATED"
            isSelected={isSelected}
            onSelect={() => onSelect({ shipmentType: 'FIRSTDIBS_FACILITATED' })}
            disabled={isComputing}
        />
    );
}

BuyerNeedsDeliveryQuote.propTypes = {
    shipmentType: PropTypes.string.isRequired,
    shipmentQuoteId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isComputing: PropTypes.bool,
};

export default BuyerNeedsDeliveryQuote;
